import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { browserHistory } from 'react-router'
import { selectors as authSelectors } from '@hixme/auth-ui'
import { selectors as userSessionSelectors } from 'store/modules/user-session'

import {
  CompanyLike,
  isDemoAllowedRoutePath,
  isDemoHrAdminRestricted,
} from './index'

/**
 * Redirects a demo company's HR admin to Home when they are on a route outside
 * the demo allow-list. Placed once in the admin shell so it covers every admin
 * route (and re-fires when the selected company hydrates after login). Other
 * roles and real (non-demo) companies are never redirected.
 */
export function useDemoRouteGuard(pathname?: string): void {
  const role = useSelector(authSelectors.getRole) as string | undefined
  const company = useSelector(userSessionSelectors.getCurrentCompanyNew) as
    | CompanyLike
    | undefined
  const restricted = isDemoHrAdminRestricted(role, company)

  useEffect(() => {
    if (restricted && !isDemoAllowedRoutePath(pathname)) {
      browserHistory.replace('/')
    }
  }, [restricted, pathname])
}
